/**
 * TaskPortalNotificationService
 * Service for task notification operations in the portal.
 * Route: api/task-portal/tasks/{taskId}/notifications
 */
import { TaskPortalBaseService } from './TaskPortalBaseService';
/**
 * TaskPortalNotificationService
 * Handles notification operations for the task portal.
 * Both creators and assignees can view notifications and mark as read.
 */
export class TaskPortalNotificationService extends TaskPortalBaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? TaskPortalNotificationService.DEFAULT_SERVICE_PATH,
            basePath: config?.basePath ?? TaskPortalNotificationService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Get all notifications for a task
     * GET /api/task-portal/tasks/{taskId}/notifications
     */
    async getNotifications(taskId) {
        const response = await this.getNotificationsRaw(taskId);
        return response.data ?? [];
    }
    getNotificationsRaw(taskId) {
        return this.get(`${taskId}/notifications`);
    }
    /**
     * Get a specific notification
     * GET /api/task-portal/tasks/{taskId}/notifications/{notificationId}
     */
    async getNotification(taskId, notificationId) {
        const response = await this.getNotificationRaw(taskId, notificationId);
        if (!response.data) {
            throw new Error(`Notification ${notificationId} not found`);
        }
        return response.data;
    }
    getNotificationRaw(taskId, notificationId) {
        return this.get(`${taskId}/notifications/${notificationId}`);
    }
    /**
     * Mark a notification as read
     * PATCH /api/task-portal/tasks/{taskId}/notifications/{notificationId}/read
     */
    async markAsRead(taskId, notificationId) {
        const response = await this.markAsReadRaw(taskId, notificationId);
        if (!response.data) {
            throw new Error('Failed to mark notification as read');
        }
        return response.data;
    }
    markAsReadRaw(taskId, notificationId) {
        return this.patch(`${taskId}/notifications/${notificationId}/read`, {});
    }
}
TaskPortalNotificationService.DEFAULT_SERVICE_PATH = 'tasks';
TaskPortalNotificationService.BASE_PATH = 'api/task-portal/tasks';
//# sourceMappingURL=TaskPortalNotificationService.js.map